/**
 * Whether the UI is running inside the Tauri desktop shell rather than a browser.
 *
 * Decided at build time rather than sniffed at runtime. The runtime signals
 * are real but fragile -- the IPC handle depends on build configuration, and
 * the origin differs by platform -- and getting this wrong silently shows the
 * web experience inside the app. The packaged build sets the flag, so it can
 * only be wrong if the build is.
 *
 * The runtime checks remain as a fallback for `tauri dev`, which does not go
 * through the packaging script.
 */
export const isDesktopApp: boolean =
  import.meta.env.VITE_DESKTOP === 'true' ||
  (typeof window !== 'undefined' &&
    ('__TAURI_IPC__' in window ||
      '__TAURI__' in window ||
      window.location.protocol === 'tauri:'))

/**
 * Where a signed-in person goes when nothing more specific was asked for.
 *
 * On the site that is `/open`, which hands over to the desktop app and falls
 * through to the download when no app answers. Inside the app itself that page
 * is nonsense -- it asks the reader to install what they are already running,
 * and then sends them to the download page -- so the app lands on Models,
 * which is what it is for.
 *
 * One constant rather than a check at each redirect, because there are five of
 * them and the next one added would have been the one that forgot.
 */
export const SIGNED_IN_HOME = isDesktopApp ? '/models' : '/open'
